import { Button } from '@/components/atoms/Button';
import { styled } from '@mui/material/styles';

interface StyledButtonProps {
  isHeader?: boolean;
}

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isHeader',
})<StyledButtonProps>(({ theme, variant, isHeader }) => ({
  width: '100%',
  maxWidth: '270px',
  minWidth: '220px',
  color: theme.palette.text.primary,
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  whiteSpace: 'nowrap',
  ...(variant === 'outlined' && {
    borderColor: theme.palette.action.active,
    '&:hover': {
      borderColor: theme.palette.action.active,
      backgroundColor: theme.palette.action.hover,
    },
  }),
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    minWidth: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    width: isHeader ? 'auto' : '100%',
    maxWidth: '100%',
    minWidth: 'auto',
  },
}));
